module.exports = __webpack_public_path__ + "static/img/06.0154aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/06.png
// module id = YUO7
// module chunks = 2